export const platformUpdatesFunctionsNames = ['setControllerProps', 'updateProps', 'updateStyles', 'handleRepeaterDataUpdate']
